<script>
  import './sass/style.scss';
  import { Router, Route, Link } from 'svelte-navigator';

  import { user } from './stores';
  import PrivateRouteGuard from './helpers/PrivateRouteGuard.svelte';

  import Nav from './components/Nav.svelte';

  import Login from './views/Login.svelte';
  import Home from './views/Home.svelte';
  import Join from './views/Join.svelte';
  import Teach from './views/Teach.svelte';
  import Profile from './views/Profile.svelte';

  import version from '../package.json';
</script>

<Router>
  <header>
    <Nav />
  </header>

  <main class="container is-fluid my-3 ">
    <Route path="/">
      <Home />
    </Route>

    <Route path="login">
      <Login />
    </Route>

    <Route path="/join/:id" let:params>
      <Join classid={params.id} />
    </Route>

    <Route path="teach">
      <PrivateRouteGuard>
        <Teach />
      </PrivateRouteGuard>
    </Route>

    <Route path="profile">
      <PrivateRouteGuard>
        <Profile />
      </PrivateRouteGuard>
    </Route>
  </main>

  <footer class="footer">
    <div class="content has-text-centered">
      <p>
        <strong>Class Timer</strong> by
        <a href="https://twitter.com/olearycrew">Brendan O'Leary</a>
        <br />
        Made with 💜 &nbsp; in Maryland
        <br />
        v{version.version}
      </p>
      <p>
        <a href="https://www.buymeacoffee.com/olearycrew" target="_blank">
          <img
            src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
            alt="Buy Me A Coffee"
            style="height: 60px !important;width: 217px !important;"
          />
        </a>
      </p>
    </div>
  </footer>
</Router>
